
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 138793","transform":"translate(-.055)"}},[_c('rect',{attrs:{"data-name":"Rectangle 111408","width":"46","height":"46","rx":"12","transform":"translate(.055)","fill":"#ef5350","opacity":".1"}}),_c('g',{attrs:{"data-name":"Group 135573"}},[_c('g',{attrs:{"fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/receipt-minus"}},[_c('path',{attrs:{"d":"M34.722 17v2.823a2.806 2.806 0 01-3.01 3.01h-3.99v-8.155a2.355 2.355 0 012.357-2.345A4.66 4.66 0 0134.722 17z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.388 18.166V34.5a1.163 1.163 0 001.867.933l1.995-1.493a1.175 1.175 0 011.54.117l1.937 1.948a1.176 1.176 0 001.657 0l1.96-1.96a1.157 1.157 0 011.517-.105l1.994 1.493a1.169 1.169 0 001.867-.933V14.666a2.34 2.34 0 012.333-2.333h-14c-3.5 0-4.667 2.088-4.667 4.667z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.347 21.667h6.417","opacity":".4"}})])])])])
          )
        }
      }
    